/**
 * @generated SignedSource<<509008b2b12751addd1d8307a66c85a2>>
 * @relayHash 12be330ffa46ee15f9b3fab11a1128a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57c5113ed107829ab285c092cd84512e113d285dd0fee5fba1726ecb7cbe7852

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceInlineTaskStatus = "COMPLETE" | "INCOMPLETE" | "%future added value";
export type InlineTasksQuerySortColumn = "ASSIGNEE" | "DUE_DATE" | "PAGE_TITLE" | "%future added value";
export type InlineTasksQuerySortOrder = "ASCENDING" | "DESCENDING" | "%future added value";
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type InlineTasksByMetadata = {
  accountIds?: InlineTasksQueryAccountIds | null | undefined;
  after?: string | null | undefined;
  completedDateRange?: InlineTasksQueryDateRange | null | undefined;
  createdDateRange?: InlineTasksQueryDateRange | null | undefined;
  dueDate?: InlineTasksQueryDateRange | null | undefined;
  first: number;
  forCurrentPageOnly?: boolean | null | undefined;
  isNoDueDate?: boolean | null | undefined;
  pageIds?: ReadonlyArray<AGG$Long | null | undefined> | null | undefined;
  sortParameters?: InlineTasksQuerySortParameters | null | undefined;
  spaceIds?: ReadonlyArray<AGG$Long | null | undefined> | null | undefined;
  status?: TaskStatus | null | undefined;
};
export type InlineTasksQueryAccountIds = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  completedByAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  creatorAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type InlineTasksQueryDateRange = {
  endDate?: AGG$Long | null | undefined;
  startDate?: AGG$Long | null | undefined;
};
export type InlineTasksQuerySortParameters = {
  sortColumn: InlineTasksQuerySortColumn;
  sortOrder: InlineTasksQuerySortOrder;
};
export type GetTasksQuery$variables = {
  taskQuery: InlineTasksByMetadata;
};
export type GetTasksQuery$data = {
  readonly inlineTasks: {
    readonly endCursor: string | null | undefined;
    readonly inlineTasks: ReadonlyArray<{
      readonly assignedTo: {
        readonly accountId: string;
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
      readonly body: {
        readonly adf: string | null | undefined;
      } | null | undefined;
      readonly container: {
        readonly __typename: "ConfluenceBlogPost";
        readonly blogPostId: string;
        readonly id: string;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webUi: string | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly spaceId: string;
        } | null | undefined;
        readonly title: string | null | undefined;
      } | {
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webUi: string | null | undefined;
        } | null | undefined;
        readonly pageId: string;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly spaceId: string;
        } | null | undefined;
        readonly title: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly createdAt: string | null | undefined;
      readonly createdBy: {
        readonly accountId: string;
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly dueAt: string | null | undefined;
      readonly id: string;
      readonly status: ConfluenceInlineTaskStatus | null | undefined;
      readonly taskId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type GetTasksQuery = {
  response: GetTasksQuery$data;
  variables: GetTasksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskQuery"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "tasksQuery",
    "variableName": "taskQuery"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "taskId"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
},
v5 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v9 = {
  "kind": "ScalarField",
  "name": "dueAt"
},
v10 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "profilePicture",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    }
  ]
},
v11 = {
  "concreteType": "ConfluenceContentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "adf"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "title"
},
v15 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "spaceId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    }
  ]
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "pageId"
    },
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    },
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "type": "ConfluencePage"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "blogPostId"
    },
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    },
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "type": "ConfluenceBlogPost"
},
v18 = {
  "kind": "ScalarField",
  "name": "endCursor"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GetTasksQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          },
          (v18/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetTasksQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          (v18/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "12be330ffa46ee15f9b3fab11a1128a5",
    "id": "57c5113ed107829ab285c092cd84512e113d285dd0fee5fba1726ecb7cbe7852",
    "metadata": {},
    "name": "GetTasksQuery",
    "operationKind": "query",
    "text": "query GetTasksQuery($taskQuery:InlineTasksByMetadata!){inlineTasks(tasksQuery:$taskQuery){inlineTasks{id,taskId,status,createdBy{accountId,displayName},createdAt,dueAt,assignedTo{accountId,displayName,profilePicture{path}},body{adf},container{__typename,...on ConfluencePage{id,pageId,links{base,webUi},title,space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,links{base,webUi},title,space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
  }
};
})();

(node as any).hash = "66d0b46ecf91b747783c5b363d1d4898";

export default node;
